/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsPong
 */
export interface WsPong {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsPong
     */
    type?: string | null;
}

/**
 * Check if a given object implements the WsPong interface.
 */
export function instanceOfWsPong(value: object): value is WsPong {
    return true;
}

export function WsPongFromJSON(json: any): WsPong {
    return WsPongFromJSONTyped(json, false);
}

export function WsPongFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsPong {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function WsPongToJSON(json: any): WsPong {
    return WsPongToJSONTyped(json, false);
}

export function WsPongToJSONTyped(value?: WsPong | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

